import type { MySubscriptionView } from "../api/myBillingService";

/**
 * 套餐到期站内提醒(修复波 0926 第八批 Z3;遗漏审计 #14「租户侧没有主动通知」)。只做站内,不推企微。
 *
 * 口径:
 *   - 已到期(status=expired,或到期时刻已过):「套餐已到期，功能已暂停，请联系我们续费」
 *   - 剩余 ≤ {@link EXPIRY_WARN_DAYS} 天(且仍生效):「套餐将于 {日期} 到期，请联系我们续费」
 *   - 已提前续费(有待生效的下一期)/ 永久套餐(>3650 天,同页「不限期」口径)/ 无订阅 → 不提醒
 * 日期取 effectiveTo 前 10 位(后端给本地时刻,与同页「订阅周期」同口径)。
 * 数据源 = GET /tenant/billing/me 的 subscription(daysRemaining 后端已 clamp 到 ≥0,所以「过了」要看 effectiveTo)。
 */
export const EXPIRY_WARN_DAYS = 15;

export type ExpiryNotice = { kind: "expiring" | "expired"; text: string };

type SubLike = Pick<
  MySubscriptionView,
  "status" | "daysRemaining" | "effectiveTo" | "nextPeriodStartsAt"
>;

export function expiryNotice(
  sub: SubLike | null | undefined,
  now: Date = new Date()
): ExpiryNotice | null {
  if (!sub) return null;
  if (sub.nextPeriodStartsAt) return null;
  const endMs = sub.effectiveTo ? Date.parse(sub.effectiveTo) : NaN;
  const passed = Number.isFinite(endMs) && endMs <= now.getTime();
  if (sub.status === "expired" || (sub.status === "active" && passed)) {
    return { kind: "expired", text: "套餐已到期，功能已暂停，请联系我们续费" };
  }
  if (sub.status !== "active") return null;
  const days = sub.daysRemaining;
  if (typeof days !== "number" || days > EXPIRY_WARN_DAYS) return null;
  const date = sub.effectiveTo ? sub.effectiveTo.slice(0, 10) : "";
  if (!date) return null;
  return { kind: "expiring", text: `套餐将于 ${date} 到期，请联系我们续费` };
}

/** 本地日期 YYYY-MM-DD(「当天不再弹」的 key 用,按用户所在时区换天)。 */
export function localDateKey(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
